// allow importing history for use outside Router
import { createBrowserHistory } from "history";
const history = createBrowserHistory();
export default history;